import * as Icon from "@ant-design/icons";
import { Modal, Form, Row, Col, Flex } from "antd";
import Search from "antd/lib/input/Search";
import { ColumnsType } from "antd/lib/table/interface";
import { useEffect } from "react";
import { AtivoModel } from "../../models/ativoModel";
import { Vm_ContaBancoModel } from "../../models/contaBanco/vm_contaBancoModel";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { buscarBanco } from "../../services/bancoService";
import { atualizarContaBancoAtivo, buscarContaBanco, deletarContaBanco } from "../../services/contaBancoService";
import { buscarEmpresa } from "../../services/empresaService";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import CadastroContaBanco from "./modals/cadastrar";
import { listarCategoriaContaBanco } from "../../services/categoriaContaBancoService";
import { BuscarContaBancoModel } from "../../models/contaBanco/buscarContaBancoModel";
import { setBuscaContaBanco, setEntityContaBanco, setModalCadastrarContaBanco, setModalDeletarContaBanco } from "../../redux/slices/contaBanco/contaBancoSlice";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { ButtonComponent } from "../../components/button/cadastrar";
import TableComponent from "../../components/table/tableComponent";
import MensagemModal from "../../components/modal/mensagem";
import { SwitchComponent } from "../../components/button/switch";

const ContaBanco = () => {
  //estados globais
  const contaBancoState = useAppSelector((state) => state.contaBanco);
  const empresaState = useAppSelector((state) => state.empresa);
  const bancoState = useAppSelector((state) => state.banco);
  const categoriaContaBancoState = useAppSelector((state) => state.categoriaContaBanco);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  const editar = Object.values(contaBancoState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("CONTAS BANCÁRIAS"));
    if (bancoState.list.length === 0) dispatch(buscarBanco(bancoState.busca));
    if (empresaState.list.length === 0) dispatch(buscarEmpresa(empresaState.busca));
    if (categoriaContaBancoState.list.length === 0) dispatch(listarCategoriaContaBanco());
    
    dispatch(buscarContaBanco(contaBancoState.busca));

    form.setFieldsValue({
      pesquisar: contaBancoState.busca.pesquisar,
    });
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityContaBanco({}));
    dispatch(setModalCadastrarContaBanco(true));
  };

  const goEditar = (value: Vm_ContaBancoModel) => {
    dispatch(setEntityContaBanco(value));
    dispatch(setModalCadastrarContaBanco(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarContaBanco(false));
  };

  const goDeletar = (value: Vm_ContaBancoModel) => {
    dispatch(setEntityContaBanco(value));
    dispatch(setModalDeletarContaBanco(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarContaBanco(false));
  };

  const onChangeAtivo = (contaBanco: Vm_ContaBancoModel) => {
    let args: AtivoModel = {
      id: contaBanco.id,
      ativo: !contaBanco.ativo,
    };
    dispatch(atualizarContaBancoAtivo({ value: args, busca: contaBancoState.busca }));
  };

  const onSearch = (value: string) => {
    let args: BuscarContaBancoModel = { ...contaBancoState.busca, pesquisar: value };

    dispatch(setBuscaContaBanco(args));
    dispatch(buscarContaBanco(args));
  };

  const filtroBanco = () =>
    Array.from(
      new Set<any>(
        bancoState.list.map((a: any) => ({
          text: a.denominacao,
          value: a.denominacao,
        }))
      )
    );

  const filtroCategoriaContaBanco = () =>
    Array.from(
      new Set<any>(
        categoriaContaBancoState.list.map((a: any) => ({
          text: a.denominacao,
          value: a.denominacao,
        }))
      )
    );

  const filtroEmpresa = () =>
    Array.from(
      new Set<any>(
        empresaState.list.map((a: any) => ({
          text: a.apelido,
          value: a.apelido,
        }))
      )
    );

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<Vm_ContaBancoModel> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacaoPersonalizada",
      sorter: (a, b) => a.denominacaoPersonalizada.localeCompare(b.denominacaoPersonalizada),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "BANCO",
      dataIndex: "denominacaoBanco",
      filters: filtroBanco(),
      onFilter: (value: any, record: any) => record.denominacaoBanco === value,
    },
    {
      title: "AGÊNCIA",
      dataIndex: "agencia",
    },
    {
      title: "CONTA",
      dataIndex: "numeroConta",
    },
    {
      title: "CATEGORIA",
      dataIndex: "denominacaoCategoriaContaBanco",
      filters: filtroCategoriaContaBanco(),
      onFilter: (value: any, record: any) => record.denominacaoCategoriaContaBanco === value,
    },
    {
      title: "EMPRESA",
      dataIndex: "denominacaoEmpresa",
      filters: filtroEmpresa(),
      onFilter: (value: any, record: any) => record.denominacaoEmpresa === value,
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      width: 100,
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.ativo.toString().includes(value),
      defaultFilteredValue: ["true" as any],
      render: (_, record) => <SwitchComponent onChange={() => onChangeAtivo(record)} checked={record.ativo} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Denominacao, Agência ou Conta" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={contaBancoState.list} columns={columns} loading={contaBancoState.loading} />
      <Modal
        title={editar ? "EDITAR CONTAS BANCÁRIAS" : "NOVA CONTA BANCÁRIA"}
        centered
        width={1150}
        open={contaBancoState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroContaBanco />
      </Modal>
      <Modal title={"REMOVER CONTA BANCÁRIA"} centered width={350} open={contaBancoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover essa conta bancária?"
          action={deletarContaBanco({ value: contaBancoState.entity.id, busca: contaBancoState.busca })}
          close={setModalDeletarContaBanco(false)}
        />
      </Modal>
    </Flex>
  );
};

export default ContaBanco;
